import { render, staticRenderFns } from "./replace-question.vue?vue&type=template&id=fa183998&scoped=true"
import script from "./replace-question.vue?vue&type=script&lang=js"
export * from "./replace-question.vue?vue&type=script&lang=js"
import style0 from "./replace-question.vue?vue&type=style&index=0&id=fa183998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa183998",
  null
  
)

export default component.exports